export const CONVERSATION_CONTEXT_SELECT = 'context-select';
export const CONVERSATION_HISTORY = 'conversation-history';
export const CONVERSATION_HISTORY_MEDIA = 'conversation-history-media';
